module.exports = __webpack_public_path__ + "static/media/google_app_store@2x.55268d57.png";


/*****************
 ** WEBPACK FOOTER
 ** ./src/assets/google_app_store@2x.png
 ** module id = 93
 ** module chunks = 0
 **/